import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export function MissingNotificationEmailNotice() {
  return (
    <p
      role="status"
      className="flex items-start gap-2 rounded-md border border-primary/40 bg-accent px-3 py-2 text-sm text-accent-foreground"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        Nemáte nastavený e-mail pro rezervace, žádosti o potvrzení vám nechodí. Doplňte ho v{" "}
        <Link to="/settings" className="font-medium underline underline-offset-4">
          Nastavení podniku
        </Link>
        .
      </span>
    </p>
  );
}
